import { getLayoutItemDefaultValue } from './getLayoutItemDefaultValue';
import { isEmptyValue } from '../managerUtils';
import { LayoutInlineForm } from '../../types/types';

// Fills empty fields with the definition defaults, in order: item `default`,
// control `default`, the first option (radioBtn/combobox) — otherwise the
// field stays empty. Runs when the values enter the editor state (objects on
// load/create, matrix dialog seed); returns the original object unchanged
// when there is nothing to fill.
export const applyLayoutObjectDefaults = <T extends Record<string, unknown>>(
  object: T | undefined,
  form: LayoutInlineForm | undefined
): T => {
  // Fixed layouts come without a canvas — the defaults then build the whole object.
  const source = object ?? ({} as T);

  if (!form) {
    return source;
  }

  let result = source;

  form.items.forEach((item) => {
    if (!item.name || !isEmptyValue(result[item.name])) {
      return;
    }

    const defaultValue = getLayoutItemDefaultValue(item);

    if (defaultValue === undefined || defaultValue === null) {
      return;
    }

    if (result === source) {
      result = { ...source };
    }

    (result as Record<string, unknown>)[item.name] = defaultValue;
  });

  return result;
};
